import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export const toastMessage = (
  text,
  config = {
    text,
    close: true,
    gravity: "bottom",
    position: "right",
    stopOnFocus: true,
  },
) => {
  Toastify(config).showToast();
};
